import { isArray, isBoolean, isDate, isNumber, isString, isValid, isHTMLElement } from "@visactor/vutils";

import { isDataView } from "@visactor/vdataset";

export function cloneDeepSpec(spec, excludeKeys = [ "data" ]) {
    const value = spec;
    let result;
    if (!isValid(value) || "object" != typeof value) return value;
    if (isDataView(value) || isHTMLElement(value)) return value;
    const isArr = isArray(value), length = value.length;
    result = isArr ? new Array(length) : "object" == typeof value ? {} : isBoolean(value) || isNumber(value) || isString(value) ? value : isDate(value) ? new Date(+value) : void 0;
    const props = isArr ? void 0 : Object.keys(Object(value));
    let index = -1;
    if (result) for (;++index < (props || value).length; ) {
        const key = props ? props[index] : index, subValue = value[key];
        (null == excludeKeys ? void 0 : excludeKeys.includes(key.toString())) ? result[key] = subValue : result[key] = cloneDeepSpec(subValue, excludeKeys);
    }
    return result;
}
//# sourceMappingURL=clone-deep.js.map